export default "__VITE_ASSET__ZBUUQHHj__"